import React from 'react';
import { Control, Controller, FieldArrayWithId } from 'react-hook-form';
import { EventFormFieldsUpdate } from '../../EventStepForm/components/EventFormBody/types';
import EventFormField from '../../../components/EventFormField/EventFormField';
import { ViewModeDictionary } from '../../../components/EventFormField/EventFormField.types';
import { EventFormViewDetailsWrapper } from './EventFormViewDetailsWrapper';

type EventFormViewDetailsEditProps = {
  fields: FieldArrayWithId<EventFormFieldsUpdate, 'fields', 'customId'>[];
  control: Control<EventFormFieldsUpdate, any>;
};

export const EventFormViewDetailsEdit: React.FC<EventFormViewDetailsEditProps> = ({ fields, control }) => {
  return (
    <EventFormViewDetailsWrapper>
      {fields.map((formField, index) => (
        <Controller
          key={formField.id}
          name={`fields.${index}`}
          control={control}
          render={({ field: reactFormField }) => {
            const { onChange, value: fieldInfo } = reactFormField;

            return (
              <EventFormField
                fieldId={fieldInfo.id}
                mode={ViewModeDictionary.INTERACTIVE}
                inputType={fieldInfo.type}
                helper={fieldInfo.helptext ?? undefined}
                label={fieldInfo.label}
                isRequired={fieldInfo.mandatory}
                fieldValues={fieldInfo.values}
                multi={fieldInfo.multi}
                resourceSubType={fieldInfo.resource_sub_type}
                options={
                  fieldInfo.type === 'dropdown' || fieldInfo.type === 'checkbox' || fieldInfo.type === 'radio'
                    ? fieldInfo.options
                    : undefined
                }
                onChange={(valueArray) => {
                  const updatedField = {
                    ...fieldInfo,
                    values: [...valueArray],
                  };
                  onChange(updatedField);
                }}
                data-cy={`input-${fieldInfo.type}`}
              />
            );
          }}
        />
      ))}
    </EventFormViewDetailsWrapper>
  );
};
